var React = require('react');

function IcNavExpo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 6.5c0-1.11-.89-2-2-2h-4v-2c0-1.11-.89-2-2-2H8c-1.11 0-2 .89-2 2v2H2c-1.11 0-1.99.89-1.99 2L0 17.5c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2v-11zm-8-2v-2H8v2h4zm-10 2v11h16v-11H2z","fill":"currentColor"}));
}

IcNavExpo.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = IcNavExpo;

IcNavExpo.default = IcNavExpo;
